import React from 'react';

// Full class strings (not interpolated) so Tailwind's JIT keeps them.
const TONE_CLASSES = {
  green: 'bg-green-50 text-green-700',
  red: 'bg-red-50 text-red-600',
  amber: 'bg-amber-50 text-amber-700',
  neutral: 'bg-gray-100 text-gray-500',
};
const DOT_CLASSES = {
  green: 'bg-green-500',
  red: 'bg-red-500',
  amber: 'bg-amber-500',
  neutral: 'bg-gray-400',
};
const TONE_BY_KEYWORD = {
  active: 'green', approved: 'green', validated: 'green',
  inactive: 'red', rejected: 'red',
  draft: 'neutral', submitted: 'amber', pending_approval: 'amber', 'pending approval': 'amber',
};

export default function StatusPill({ value, label, tone, dot = false }) {
  const key = String(value ?? label ?? '').toLowerCase();
  const resolved = tone || TONE_BY_KEYWORD[key] || 'neutral';
  const text = label ?? String(value ?? '').replace(/_/g, ' ');
  const display = text.charAt(0).toUpperCase() + text.slice(1);
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-semibold leading-none ${TONE_CLASSES[resolved]}`}>
      {dot && <span className={`h-1.5 w-1.5 rounded-full ${DOT_CLASSES[resolved]}`} />}
      {display}
    </span>
  );
}
